{
    "name": "sharemac-project-planner-angular",
    "version": "8.0.0",
    "scripts": {
        "ng": "ng",
        "format": "prettier --write \"src/**/*.{ts,html,scss,css,json}\"",
        "format:check": "prettier --check \"src/**/*.{ts,html,scss,css,json}\"",
        "start": "ng serve",
        "serve": "ng serve --host=0.0.0.0",
        "serve:docker": "ng serve --host=pp.sharemac.localhost",
        "start:dev": "ng serve --configuration development",
        "start:prod": "ng serve  --configuration production",
        "start:strabag:prod": "ng serve  --configuration strabag-prod",
        "start:strabag:dev": "ng serve --configuration strabag-dev",
        "start:strabag:pre-prod": "ng serve  --configuration strabag-pre-prod",
        "build:pre-prod": "ng build  --configuration pre-prod",
        "build:prod:sentry": "ng build  --configuration production && npm run sentry:sourcemaps",
        "build:prod": "ng build --configuration production",
        "build:strabag:prod": "ng build  --configuration strabag-prod",
        "build:strabag:pre-prod": "ng build  --configuration strabag-pre-prod",
        "build:strabag:dev": "ng build  --configuration strabag-dev",
        "build:dev": "ng build --configuration development",
        "build:stats": "ng build --stats-json",
        "test": "jest",
        "test:watch": "jest --watch --coverage=false",
        "test:coverage": "jest --coverage",
        "lint": "eslint . --ext .ts,.html",
        "lint:fix": "eslint . --ext .ts,.html --fix",
        "lint:rules:test": "node --test \"tools/eslint-plugin-syniotec/rules/*.test.js\"",
        "e2e": "ng e2e --dev-server-target=",
        "postinstall": "patch-package",
        "analyzer": "webpack-bundle-analyzer dist/sam/browser/stats.json",
        "prepare": "husky install",
        "generate:palette": "gulp generate:palette",
        "sentry:sourcemaps": "sentry-cli sourcemaps inject --org syniotec-techhub --project sam-frontend ./dist/sam/browser && sentry-cli sourcemaps upload --org syniotec-techhub --project sam-frontend ./dist/sam/browser"
    },
    "extensionDependencies": [
        "vunguyentuan.vscode-css-variables"
    ],
    "private": true,
    "dependencies": {
        "@ag-grid-community/locale": "~33.2.4",
        "@angular/animations": "19.2.14",
        "@angular/cdk": "19.2.19",
        "@angular/common": "19.2.14",
        "@angular/compiler": "19.2.14",
        "@angular/core": "19.2.14",
        "@angular/forms": "19.2.14",
        "@angular/google-maps": "19.2.19",
        "@angular/localize": "19.2.14",
        "@angular/material": "19.2.19",
        "@angular/platform-browser": "19.2.14",
        "@angular/platform-browser-dynamic": "19.2.14",
        "@angular/router": "19.2.14",
        "@apollo/client": "^3.13.1",
        "@fortawesome/fontawesome-free": "^6.7.2",
        "@iharbeck/ngx-virtual-scroller": "^17.0.2",
        "@mobiscroll/angular": "npm:@mobiscroll/angular-ivy@5.33.0",
        "@ng-select/ng-select": "^14.2.2",
        "@ngneat/svg-icon": "7.1.6",
        "@ngneat/until-destroy": "^9.2.3",
        "@ngrx/component-store": "19.2.1",
        "@ngrx/effects": "19.2.1",
        "@ngrx/entity": "19.2.1",
        "@ngrx/operators": "^19.2.1",
        "@ngrx/router-store": "19.2.1",
        "@ngrx/signals": "19.2.1",
        "@ngrx/store": "19.2.1",
        "@ngx-translate/core": "^17.0.0",
        "@ngx-translate/http-loader": "^7.0.0",
        "@sentry/angular": "^8.55.0",
        "@sharemactechhub/frontend-library": "19.0.147",
        "@swimlane/ngx-charts": "^20.5.0",
        "@syniotec-techhub/assets": "1.5.0",
        "@syniotec-techhub/common": "^19.31.0",
        "@syniotec-techhub/core": "^19.26.2",
        "@syniotec-techhub/ui": "^19.49.1",
        "@tweenjs/tween.js": "^23.1.1",
        "@videojs/http-streaming": "^3.15.0",
        "ag-charts-angular": "^12.3.0",
        "ag-grid-angular": "~33.2.1",
        "ag-grid-community": "~33.2.1",
        "ag-grid-enterprise": "~33.2.1",
        "angular-svg-icon": "^19.1.1",
        "angularx-qrcode": "^19.0.0",
        "apollo-angular": "11.0.0",
        "chart.js": "^3.7.1",
        "chartjs-plugin-datalabels": "^2.0.0",
        "chartjs-plugin-zoom": "^2.2.0",
        "date-fns": "^4.1.0",
        "date-holidays": "^3.23.18",
        "es-module-shims": "^1.5.12",
        "event-source-polyfill": "^1.0.8",
        "file-saver": "^2.0.5",
        "graphql": "^16.8.0",
        "hammerjs": "^2.0.8",
        "hls.js": "^1.5.20",
        "jwt-decode": "^3.0.0",
        "lodash-es": "^4.17.11",
        "lottie-web": "^5.12.2",
        "moment": "^2.30.1",
        "moment-timezone": "0.5.47",
        "ng-mocks": "^14.13.2",
        "ng-otp-input": "^1.8.5",
        "ng-primitives": "0.89.0",
        "ng2-charts": "^3.0.11",
        "ngrx-store-localstorage": "^19.0.0",
        "ngx-color-picker": "^18.0.0",
        "ngx-cookie-service": "^19.1.0",
        "ngx-image-cropper": "^6.3.4",
        "ngx-infinite-scroll": "19.0.0",
        "ngx-lottie": "^13.0.0",
        "ngx-mask": "19.0.6",
        "ngx-permissions": "^17.0.0",
        "notyf": "^3.10.0",
        "patch-package": "^8.0.1",
        "quill": "^2.0.3",
        "rxjs": "~7.8.1",
        "signature_pad": "^5.1.4",
        "socket.io-client": "^4.8.1",
        "subscriptions-transport-ws": "^0.11.0",
        "tslib": "^2.8.1",
        "underscore": "^1.13.7",
        "uuid": "^11.1.0",
        "video.js": "^8.21.0",
        "videojs-contrib-quality-levels": "^4.1.0",
        "zod": "4.4.3",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular-architects/native-federation": "19.0.23",
        "@angular-devkit/build-angular": "19.2.15",
        "@angular-eslint/builder": "19.0.2",
        "@angular-eslint/eslint-plugin": "^19.0.2",
        "@angular-eslint/eslint-plugin-template": "^19.0.2",
        "@angular-eslint/schematics": "^19.0.2",
        "@angular-eslint/template-parser": "^19.0.2",
        "@angular/build": "19.2.15",
        "@angular/cli": "19.2.15",
        "@angular/compiler-cli": "19.2.14",
        "@angular/language-service": "19.2.14",
        "@commitlint/cli": "^19.4.0",
        "@ngneat/spectator": "^19.5.0",
        "@ngrx/store-devtools": "19.2.1",
        "@types/chart.js": "^2.9.24",
        "@types/file-saver": "^2.0.0",
        "@types/google.maps": "^3.53.1",
        "@types/gulp": "^4.0.10",
        "@types/hammerjs": "^2.0.36",
        "@types/jest": "^29.5.12",
        "@types/jquery": "^3.3.25",
        "@types/moment-timezone": "^0.5.12",
        "@types/mousetrap": "^1.6.3",
        "@types/node": "^20.17.17",
        "@types/qs": "^6.9.18",
        "@types/underscore": "^1.9.4",
        "@types/url-parse": "^1.4.3",
        "@typescript-eslint/eslint-plugin": "7.11.0",
        "@typescript-eslint/parser": "7.11.0",
        "@typescript-eslint/types": "^7.18.0",
        "@typescript-eslint/utils": "^7.11.0",
        "codelyzer": "^6.0.2",
        "eslint": "^8.57.0",
        "eslint-config-prettier": "^10.1.8",
        "eslint-plugin-prettier": "^5.5.6",
        "eslint-plugin-promise": "^6.1.1",
        "eslint-plugin-simple-import-sort": "^14.0.0",
        "eslint-plugin-syniotec": "file:tools/eslint-plugin-syniotec",
        "eslint-plugin-unused-imports": "^3.1.0",
        "gulp": "^5.0.0",
        "gulp-sass": "^5.1.0",
        "husky": "^8.0.0",
        "jest": "^29.7.0",
        "jest-canvas-mock": "^2.5.2",
        "jest-junit": "^16.0.0",
        "jest-marbles": "^3.1.0",
        "jest-preset-angular": "^14.5.1",
        "lint-staged": "~15.2.10",
        "prettier": "^3.5.3",
        "pretty-quick": "^4.1.1",
        "sass": "^1.85.0",
        "ts-jest": "^29.1.2",
        "ts-node": "~10.9.1",
        "typescript": "5.5.4",
        "webpack-bundle-analyzer": "^4.5.0"
    },
    "lint-staged": {
        "**/*.{js,ts,jsx,tsx}": "eslint --fix",
        "**/*.html": [
            "eslint --fix",
            "prettier --write"
        ]
    }
}
